import { Component, Input, ViewEncapsulation } from '@angular/core';
import { NgModel } from '@angular/forms';

@Component({
    selector: 'fi-change-password-tooltip',
    templateUrl: './change-password-tooltip.component.html',
    encapsulation: ViewEncapsulation.None,
    styles: [
        `
            fi-change-password-tooltip {
                color: #333;
                text-align: left;
            }
        `,
    ],
    host: { class: 'fi-change-password-tooltip' },
    standalone: false,
})
export class FiChangePasswordTooltipComponent {
    @Input() passwordModel: NgModel;
    @Input() confirmPasswordModel: NgModel;
}
